import { FC } from "react";
import { Avatar } from "@mui/material";
import moment from "moment";

// Shared "Created By" grid cell — avatar + user name + created datetime, matching
// the invoice listing's Created By column. Used by the GRN / Requisition /
// Stock Transfer lists. `createdBy` is the populated User ({ name, profilePic }).
interface Props {
  createdBy?: any;
  createdAt?: any;
}

const initials = (name?: string) =>
  name?.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "?";

const CreatedByCell: FC<Props> = ({ createdBy, createdAt }) => {
  const when = createdAt ? moment(createdAt).format("DD MMM YYYY, hh:mm A") : "-";
  return (
    // <Tooltip title={`${createdBy?.name || "-"} | ${when}`} arrow>
      // Plain divs, not MUI Box: the data grid styles every .MuiBox-root inside
      // it with `margin-bottom: 10px`, which knocks this cell off centre.
      <div style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
        <Avatar src={createdBy?.profilePic || ""} sx={{ width: 35, height: 35, fontSize: "0.6rem", mr: 1, flexShrink: 0 }}>
          {initials(createdBy?.name)}
        </Avatar>
        <div style={{ minWidth: 0, lineHeight: 1.2, overflow: "hidden" }}>
          <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{createdBy?.name || "-"}</div>
          <span style={{ color: "#888", fontSize: "0.75rem", display: "block" }}>{when}</span>
        </div>
      </div>
    // </Tooltip>
  );
};

export default CreatedByCell;
